/**
 * Error correction level values
 */
export enum ErrorCorrectionLevelValue {
  L = 0,
  M = 1,
  Q = 2,
  H = 3,
}
